import type { GetNarrativeClustersTableVariables } from "@/data-access/discovery-view/queries/discovery-view-queries";
import type { SortModelItem } from "ag-grid-community";

/** Maps narrative clusters table column IDs to StoryOrder fields. */
const NARRATIVE_CLUSTER_COL_TO_STORY_ORDER: Partial<
  Record<
    string,
    keyof NonNullable<GetNarrativeClustersTableVariables["ordering"]>[number]
  >
> = {
  TOTAL_MENTIONS: "totalMentions",
  NET_IMPACT_SCORE: "netImpactScore",
  AVERAGE_ARTICLE_IMPACT: "averageArticleImpact",
  AVERAGE_IMPACT_STRENGTH: "averageImpactStrength",
  READERSHIP: "readership",
  SOCIAL_ENGAGEMENTS: "socialEngagement",
  NET_SENTIMENT: "netSentiment",
  GROSS_IMPACT: "grossImpact",
  GROSS_POSITIVE_IMPACT: "grossPositiveImpact",
  GROSS_NEUTRAL_IMPACT: "grossNeutralImpact",
  GROSS_NEGATIVE_IMPACT: "grossNegativeImpact",
  TIER_1: "tier1",
  TIER_2: "tier2",
  TIER_3: "tier3",
  HEADLINES: "headlines",
  FEATURES: "features",
  PASSING_MENTIONS: "passingMentions",
};

/** Converts AG Grid sort model to StoryOrder for narrative clusters table. */
export const convertSortModelToStoryOrdering = (
  sortModel: SortModelItem[],
): GetNarrativeClustersTableVariables["ordering"] => {
  if (sortModel.length === 0) return undefined;
  const firstSort = sortModel[0];
  if (!firstSort) return undefined;
  const graphqlField = NARRATIVE_CLUSTER_COL_TO_STORY_ORDER[firstSort.colId];
  if (!graphqlField) return undefined;
  const orderingValue =
    firstSort.sort === "desc" ? "DESC_NULLS_LAST" : "ASC_NULLS_LAST";
  return [
    { [graphqlField]: orderingValue },
  ] as GetNarrativeClustersTableVariables["ordering"];
};
